
Vite is great for frontend JavaScript as ESM modules. But what about native Node.js typescript code? I want to be able to write for the backend and the frontend in one fell swoop. Similar to how SSR works for Vite but not quite.

What I'm really looking for is 3 parts:

- frontend ESM bundler
- backend ESM (browser sim) SSR
- backend ESM Node.js environment api

This would be the ideal.
